import React,{useState,useEffect,useContext} from 'react';
import DeviceProfilesTable from '../../../components/LoraNetworks/DeviceProfilesTable/DeviceProfilesTable';
import CreateDeviceProfile from '../../../components/LoraNetworks/CreateDeviceProfile/CreateDeviceProfile';
import LoraLayout from '../../../components/LoraNetworks/LoraLayout/LoraLayout';
import { ToastContainer, Zoom } from 'react-toastify';
import { useAxios } from '../../../utils/Axios';
import Context from '../../../store/Context';


function DeviceProfiles() {
    const [deviceProfiles, setDeviceProfiles] = useState([]);
    const [nwServers, setNwServers] = useState([]);
    const [optionsEnabled, setOptionsEnabled] = useState({
        createDP: false,
        editdeleteDP : false
    })
    const axiosInstance = useAxios();
    const {state , actions} = useContext(Context);

    useEffect(() => {
        checkCurrentUser()
    }, [axiosInstance])

    useEffect(() => {
		fetchDeviceProfilesList();
    }, [axiosInstance]);
    
    //code to check current user role
    function checkCurrentUser() {
        let roles = JSON.parse(localStorage.getItem("roles"));
        // let roles = ["ln_user"]

        // console.log(roles.includes('ln_admin'));
        if (roles.includes('ln_admin')) {
            setOptionsEnabled(
                prevState => ({
                    ...prevState,
                    createDP : true,
                    editdeleteDP : true
                })
            )
        }
        if (roles.includes('ln_orgadmin')) {
            setOptionsEnabled(
                prevState => ({
                    ...prevState,
                    createDP : true,
                    editdeleteDP : true
                })
            )
        }
        if (roles.includes('ln_user')) {
            setOptionsEnabled(
                prevState => ({
                    ...prevState,
                    createDP : false,
                    editdeleteDP : false
                })
            )
        }
        if (roles.includes('ln_deviceadmin')) {
            setOptionsEnabled(
                prevState => ({
                    ...prevState,
                    createDP : true,
                    editdeleteDP : true
                })
            )
        }

    }


    //Code to fetch Organization Device Profiles store in state
    function fetchDeviceProfilesList(){
        let reqid = localStorage.getItem('orgid');
        if (axiosInstance) {
			actions({type : 'setState', payload : {...state , blocking : true}})
			axiosInstance
				.get(`${process.env.REACT_APP_LORA_URL}/device-profiles?limit=100&organizationID=${reqid}`)
				.then((response) => {
					// console.log(response);
					setDeviceProfiles(response.data.result);

                    // actions({type : 'setState', payload : {...state , blocking : false}})
                    fetchNwServers();
				})
				.catch((err) => {
					// console.log(err);

                    // actions({type : 'setState', payload : {...state , blocking : false}})
                    fetchNwServers();
				});

		}
    }

    //Code to fetch Network-servers store in state
    function fetchNwServers(){
        // let orgid = localStorage.getItem('orgid')
        if (axiosInstance) {
            actions({type : 'setState', payload : {...state , blocking : true}})
            axiosInstance
                .get(`${process.env.REACT_APP_LORA_URL}/network-servers?limit=999`)
                .then((response) => {
                    // console.log(response);
                    setNwServers(response.data.result);

                    actions({type : 'setState', payload : {...state , blocking : false}})
                })
                .catch((err) => {
                    // console.log(err);
                    actions({type : 'setState', payload : {...state , blocking : false}})
                });

        }
    }
	const handleSubmit = (flag) => {
		// console.log(flag);
		if (flag) {

			const timer = setTimeout(() => {
				fetchDeviceProfilesList();
			}, 2000);

		};
	};
    return (
        <>
            <LoraLayout>
                <div className="col-md-12 col-sm-12 col-lg-12 no-padding">
                    <div className="row" style={{ margin: '0 3rem' }}>
                        <div
                            style={{ marginTop: '1rem', color: '#43425D' }}
                            className="col-md-6 col-sm-6 col-lg-6"
                        >
                            <h5>Device-profiles</h5>
                        </div>
                    </div>
                    <div className="default-main-page">
                        {deviceProfiles.length > 0 ? (
                            <>
                                <div className="project-table-group">
                                    <DeviceProfilesTable data={deviceProfiles} status={handleSubmit} editdelete = {optionsEnabled.editdeleteDP}/>
                                </div>
                                <br />
                                {optionsEnabled.createDP == true ? (
                                    <>
                                        <div className="col-md-12 text-right no-padding" >
                                            <CreateDeviceProfile status={handleSubmit} networks={nwServers}/>
                                        </div>
                                    </>
                                ) : null}
                            </>
                        ) : (
                                <div className="default-content-center" style={{ margin: '3%', textAlign: 'center' }}>
                                    You don't have any Org. Device Profiles right now
                                    <br />
                                    <br />
                                    {optionsEnabled.createDP == true ? (
                                        <>
                                            <div className="col-md-12 text-center no-padding" >
                                                <CreateDeviceProfile status={handleSubmit} networks={nwServers}/>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                            )}
                    </div>
                </div>
            </LoraLayout>
            <ToastContainer draggable={false} transition={Zoom}/>
        </>
    )
}

export default DeviceProfiles
